import { useCallback } from 'react';
import { path } from 'ramda';

import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { useUserSelector } from '@core/js/store/hooks';

import { useDynamicTagList } from '@interlayer/js/app/hooks/useDynamicTagList';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';
import { reverseDate } from '@interlayer/js/app/utils/common.util';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { reverseString } from '@interlayer/js/app/utils/methods.util';

export const useCheckRegPinByDOB = (t: ITranslateMethod) => {
    const birthDate = useUserSelector(path(['userDetails', 'birthDate'])) || '';
    const {
        retailRegData: { [STEP_NAMES.PERSONAL_RETAIL_STEP]: { dateOfBirth: dateOfBirthRetail } },
        registrationsData: { [STEP_NAMES.PERSONAL_STEP]: { dateOfBirth } }
    } = useRegistrationSelector();
    const dTagInvalidRegPins = useDynamicTagList({
        tagName: DYNAMIC_TAG_NAMES.invalidRegPins,
        defaultValue: '123456',
        withLowerCase: false
    });

    const userBirthDate = reverseDate(birthDate) || dateOfBirthRetail || dateOfBirth;

    return useCallback((value = '') => {
        if (
            value === value[0].repeat(value.length)
            || dTagInvalidRegPins.some(invalidPin => {
                const invalidPinClipped = invalidPin.slice(0, value.length);

                return invalidPinClipped === value || reverseString(invalidPinClipped) === value;
            })
        ) {
            return [t('pinReg.securePin')];
        }

        if (!userBirthDate) {
            return;
        }

        const [day, month, fullYear] = userBirthDate.split('-');
        const year = fullYear.slice(2);

        if ([`${day}${month}${year}`, `${day}${month}`, fullYear, `${month}${year}`].some(date => value === date)) {
            return [t('pinReg.containDate')];
        }
    }, [dTagInvalidRegPins, userBirthDate, t]);
};
